module.exports = __webpack_public_path__ + "img/al-based.de605bf9.jpg";